import React from "react";
import { Crosshair, Heart } from "lucide-react";

const DISCORD_INVITE = "https://discord.gg/nfCGCXyUY";
const KOFI_LINK = "https://ko-fi.com/datasniper";

const DiscordGlyph = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
    <path d="M20.317 4.3698a19.7913 19.7913 0 0 0-4.8851-1.5152.0741.0741 0 0 0-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 0 0-.0785-.037 19.7363 19.7363 0 0 0-4.8852 1.515.0699.0699 0 0 0-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 0 0 .0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 0 0 .0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 0 0-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 0 1-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 0 1 .0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 0 1 .0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 0 1-.0066.1276 12.2986 12.2986 0 0 1-1.873.8914.0766.0766 0 0 0-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 0 0 .0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 0 0 .0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 0 0-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z" />
  </svg>
);

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 py-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 text-[12px] text-neutral-500">
        <div className="flex items-center gap-2">
          <span className="relative inline-flex items-center justify-center w-6 h-6 border border-[#FF5000]">
            <Crosshair className="w-3.5 h-3.5 text-[#FF5000]" />
          </span>
          <span className="text-white tracking-tight">
            Data<span className="text-[#FF5000]">Sniper</span>
          </span>
          <span className="ml-3 ds-mono uppercase tracking-[0.25em] text-neutral-600">
            © {new Date().getFullYear()}
          </span>
        </div>
        <div className="flex items-center gap-6 uppercase tracking-[0.22em] text-[11px]">
          <span>Market intelligence</span>
          <span className="hidden sm:inline">·</span>
          <span>DataSniper Beta · v0.1</span>
          <a
            href={DISCORD_INVITE}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-discord"
            aria-label="Join the DataSniper Discord"
            className="inline-flex items-center gap-2 text-neutral-400 hover:text-[#5865F2] transition-colors"
          >
            <DiscordGlyph className="w-5 h-5" />
            <span className="hidden sm:inline">Discord</span>
          </a>
          <a
            href={KOFI_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-donate"
            aria-label="Donate to DataSniper on Ko-fi"
            className="inline-flex items-center gap-2 text-neutral-400 hover:text-[#FF5000] transition-colors"
          >
            <Heart className="w-4 h-4" />
            <span className="hidden sm:inline">Donate</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
